"use client";

import { getYzsaId } from "@yardzen/next-client-util";
import { useEffect, useState } from "react";

export interface UserContextData {
  email?: string;
  userId?: string;
  anonymousId?: string;
  ipAddress?: string;
  country?: string;
}

export function useUserContext(userData?: {
  email?: string;
  userId?: string;
}): UserContextData {
  const [ipAddress, setIpAddress] = useState<string>();
  const [country, setCountry] = useState<string>();
  const [anonymousId, setAnonymousId] = useState<string | undefined>();

  useEffect(() => {
    const fetchIpInfo = async () => {
      try {
        const response = await fetch("/api/get-ip");
        if (response.ok) {
          const data = await response.json();
          setIpAddress(data.ip);
          setCountry(data.country);
        } else {
          console.warn("[Datadog] IP API returned error:", response.status);
        }
      } catch (error) {
        console.warn("[Datadog] Failed to fetch IP info:", error);
      }
    };

    fetchIpInfo();
  }, []);

  // Get anonymous ID once on mount (getYzsaId now uses internal cache)
  useEffect(() => {
    try {
      const yzsa = getYzsaId();
      setAnonymousId(yzsa);
    } catch (error) {
      console.warn("[Datadog] Failed to read anonymous ID:", error);
    }
  }, []);

  return {
    email: userData?.email,
    userId: userData?.userId,
    anonymousId,
    ipAddress,
    country,
  };
}
